export default "__VITE_ASSET__DN$Kp85___"